import BigNumber from 'bignumber.js';

import { AnalyticsApi, mainApi, queryFnNotifyWrapper } from 'modules/api';
import { captureError } from 'modules/api/captureError';
import { DECIMALS, DECIMALS_RATIO } from 'modules/common';
import { t } from 'modules/i18n';

import { dashboardCacheTags } from '../cacheTags';

export interface IGetStats {
  rate: BigNumber;
  tvl: string;
  apy: number;
  apyBoosted: number;
  apyTotal: number;
  stakers: number;
  epochStartedAt: number;
  iotaUsdPrice: BigNumber;
  totalRewards: BigNumber;
}

export const { useGetStatsQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getStats: build.query<IGetStats, void>({
      queryFn: queryFnNotifyWrapper<void, void, IGetStats>(
        async () => {
          const api = AnalyticsApi.getInstance();

          const data = await api.getStats();

          return {
            data: {
              rate: new BigNumber(data.ratio).div(DECIMALS_RATIO),
              tvl: data.tvl,
              apy: data.apy,
              apyBoosted: data.boosted_apy,
              apyTotal: data.apy + data.boosted_apy,
              stakers: data.stakers,
              epochStartedAt: data.epoch_started_at,
              iotaUsdPrice: new BigNumber(data.iota_price),
              totalRewards: new BigNumber(data.total_rewards).div(DECIMALS),
            },
          };
        },
        error => {
          const message = t('notification.failedStats');
          captureError(error, message);

          return message;
        },
      ),
      providesTags: [dashboardCacheTags.getStats],
    }),
  }),
});
